// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand_brand__1ID-7","logo":"Brand_logo__2VmXa","title":"Brand_title__3cm_s"};